// Mock data simulating a real freight management system

export const SHIPMENTS = [
  {
    id: 'SHP-2024-7821',
    status: 'in_transit',
    origin: { city: 'Shanghai', country: 'CN', coords: [121.4737, 31.2304] },
    destination: { city: 'Los Angeles', country: 'US', coords: [-118.2437, 34.0522] },
    carrier: 'Maersk Line',
    carrierCode: 'MAEU',
    vessel: 'Maersk Eindhoven',
    container: 'MSKU7234891',
    containerType: '40HC',
    weight: 18420,
    cargoPorts: ['Singapore', 'Busan'],
    eta: '2024-03-28',
    etd: '2024-03-01',
    progress: 67,
    commodity: 'Electronics',
    value: 284000,
    documents: ['BOL', 'Commercial Invoice', 'Packing List'],
    alerts: [],
    lastUpdate: '2 hours ago',
    currentLocation: 'Pacific Ocean',
  },
  {
    id: 'SHP-2024-7734',
    status: 'delayed',
    origin: { city: 'Rotterdam', country: 'NL', coords: [4.4777, 51.9225] },
    destination: { city: 'New York', country: 'US', coords: [-74.006, 40.7128] },
    carrier: 'MSC',
    carrierCode: 'MSCU',
    vessel: 'MSC Gülsün',
    container: 'MSCU4491023',
    containerType: '20GP',
    weight: 9200,
    cargoPorts: ['Antwerp'],
    eta: '2024-03-22',
    etd: '2024-03-05',
    progress: 44,
    commodity: 'Automotive Parts',
    value: 167500,
    documents: ['BOL', 'Certificate of Origin'],
    alerts: [{ type: 'delay', message: 'Port congestion at Antwerp — ETA shifted by 3 days' }],
    lastUpdate: '5 hours ago',
    currentLocation: 'North Atlantic Ocean',
  },
  {
    id: 'SHP-2024-7698',
    status: 'customs',
    origin: { city: 'Mumbai', country: 'IN', coords: [72.8777, 19.076] },
    destination: { city: 'Dubai', country: 'AE', coords: [55.2708, 25.2048] },
    carrier: 'CMA CGM',
    carrierCode: 'CMAU',
    vessel: 'CMA CGM Antoine',
    container: 'CMAU8812341',
    containerType: '40GP',
    weight: 21000,
    cargoPorts: [],
    eta: '2024-03-18',
    etd: '2024-03-10',
    progress: 91,
    commodity: 'Textiles',
    value: 95000,
    documents: ['BOL', 'Commercial Invoice', 'Customs Declaration'],
    alerts: [{ type: 'customs', message: 'Held for customs inspection — documentation required' }],
    lastUpdate: '1 hour ago',
    currentLocation: 'Port of Dubai',
  },
  {
    id: 'SHP-2024-7612',
    status: 'delivered',
    origin: { city: 'Shenzhen', country: 'CN', coords: [114.0579, 22.5431] },
    destination: { city: 'Hamburg', country: 'DE', coords: [9.9937, 53.5753] },
    carrier: 'Hapag-Lloyd',
    carrierCode: 'HLCU',
    vessel: 'Madrid Express',
    container: 'HLXU3012984',
    containerType: '40HC',
    weight: 26400,
    cargoPorts: ['Port Said'],
    eta: '2024-03-12',
    etd: '2024-02-15',
    progress: 100,
    commodity: 'Consumer Goods',
    value: 412000,
    documents: ['BOL', 'Commercial Invoice', 'Packing List', 'Certificate of Origin'],
    alerts: [],
    lastUpdate: '3 days ago',
    currentLocation: 'Hamburg, Germany',
  },
  {
    id: 'SHP-2024-7588',
    status: 'in_transit',
    origin: { city: 'Busan', country: 'KR', coords: [129.0756, 35.1796] },
    destination: { city: 'Long Beach', country: 'US', coords: [-118.1937, 33.7701] },
    carrier: 'Evergreen',
    carrierCode: 'EGLV',
    vessel: 'Ever Ace',
    container: 'EGHU9023451',
    containerType: '40HC',
    weight: 19800,
    cargoPorts: ['Tokyo'],
    eta: '2024-03-30',
    etd: '2024-03-08',
    progress: 55,
    commodity: 'Machinery',
    value: 730000,
    documents: ['BOL', 'Commercial Invoice', 'Insurance Certificate'],
    alerts: [],
    lastUpdate: '30 min ago',
    currentLocation: 'North Pacific Ocean',
  },
  {
    id: 'SHP-2024-7501',
    status: 'processing',
    origin: { city: 'Chicago', country: 'US', coords: [-87.6298, 41.8781] },
    destination: { city: 'Guadalajara', country: 'MX', coords: [-103.3496, 20.6597] },
    carrier: 'J.B. Hunt',
    carrierCode: 'JBHT',
    vessel: 'N/A (Ground)',
    container: 'JBHT0092341',
    containerType: '53FT',
    weight: 14200,
    cargoPorts: [],
    eta: '2024-03-20',
    etd: '2024-03-16',
    progress: 8,
    commodity: 'Industrial Equipment',
    value: 298000,
    documents: ['BOL', 'Commercial Invoice'],
    alerts: [],
    lastUpdate: '15 min ago',
    currentLocation: 'Chicago Distribution Center',
  },
];

export const CARRIERS = [
  { name: 'Maersk Line', code: 'MAEU', onTime: 91, avgDelay: 1.2, reliability: 94, lanes: 312, rating: 4.7 },
  { name: 'MSC', code: 'MSCU', onTime: 85, avgDelay: 2.1, reliability: 87, lanes: 289, rating: 4.3 },
  { name: 'CMA CGM', code: 'CMAU', onTime: 88, avgDelay: 1.8, reliability: 90, lanes: 256, rating: 4.5 },
  { name: 'Hapag-Lloyd', code: 'HLCU', onTime: 93, avgDelay: 0.9, reliability: 95, lanes: 231, rating: 4.8 },
  { name: 'Evergreen', code: 'EGLV', onTime: 82, avgDelay: 2.4, reliability: 84, lanes: 198, rating: 4.1 },
  { name: 'COSCO', code: 'COSU', onTime: 79, avgDelay: 2.8, reliability: 81, lanes: 276, rating: 4.0 },
];

export const FREIGHT_RATES = [
  { route: 'Shanghai → LA', mode: 'Ocean FCL', rate: 2840, change: +12.4, unit: '/40HC' },
  { route: 'Rotterdam → New York', mode: 'Ocean FCL', rate: 1920, change: -4.2, unit: '/20GP' },
  { route: 'Mumbai → Dubai', mode: 'Ocean LCL', rate: 145, change: +2.1, unit: '/CBM' },
  { route: 'Shenzhen → Hamburg', mode: 'Ocean FCL', rate: 3240, change: +8.7, unit: '/40HC' },
  { route: 'Chicago → LA', mode: 'Road FTL', rate: 4800, change: -1.5, unit: '/Load' },
  { route: 'Frankfurt → Singapore', mode: 'Air Freight', rate: 5.80, change: +0.3, unit: '/KG' },
];

export const MONTHLY_VOLUME = [
  { month: 'Oct', shipments: 42, revenue: 1240000, onTime: 88 },
  { month: 'Nov', shipments: 51, revenue: 1580000, onTime: 91 },
  { month: 'Dec', shipments: 38, revenue: 1190000, onTime: 84 },
  { month: 'Jan', shipments: 63, revenue: 1920000, onTime: 87 },
  { month: 'Feb', shipments: 71, revenue: 2180000, onTime: 90 },
  { month: 'Mar', shipments: 58, revenue: 1780000, onTime: 93 },
];

export const COMMODITY_BREAKDOWN = [
  { name: 'Electronics', value: 34, fill: '#00d4ff' },
  { name: 'Automotive', value: 22, fill: '#00e5a0' },
  { name: 'Textiles', value: 18, fill: '#f5c842' },
  { name: 'Machinery', value: 14, fill: '#ff8c42' },
  { name: 'Consumer Goods', value: 12, fill: '#ff4d6a' },
];

export const STATUS_CONFIG = {
  in_transit: { label: 'In Transit', color: '#00d4ff', bg: 'rgba(0, 212, 255, 0.12)' },
  delayed: { label: 'Delayed', color: '#ff4d6a', bg: 'rgba(255, 77, 106, 0.12)' },
  customs: { label: 'Customs Hold', color: '#f5c842', bg: 'rgba(245, 200, 66, 0.12)' },
  delivered: { label: 'Delivered', color: '#00e5a0', bg: 'rgba(0, 229, 160, 0.12)' },
  processing: { label: 'Processing', color: '#ff8c42', bg: 'rgba(255, 140, 66, 0.12)' },
};

export const EXCHANGE_RATES_MOCK = {
  USD: 1,
  EUR: 0.92,
  GBP: 0.79,
  CNY: 7.23,
  SGD: 1.34,
  AED: 3.67,
};
